import { useEffect } from "react";

export default function SEOHead({ title, description }) {
  useEffect(() => {
    // Title format: Forside is "KVC Express ApS", others "[Titel på underside] - KVC Express ApS"
    const fullTitle = title ? `${title} - KVC Express ApS` : "KVC Express ApS";
    document.title = fullTitle;

    // Update meta description
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", description);
    }
  }, [title, description]);

  return null;
}
